import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { motion } from 'framer-motion';
import Button from '../components/Button';
import FriendsList from '../components/invite/FriendsList';
import { formatPrice } from '../utils/formatPrice';

interface InviteFormData {
  email: string;
}

const InvitePage: React.FC = () => {
  const [friends, setFriends] = useState<Array<{id: string; email: string; status: 'pending' | 'paid'}>>([]);
  const totalCost = 1200; // Example total cost
  const costPerPerson = totalCost / (friends.length + 1);

  const { register, handleSubmit, reset, formState: { errors } } = useForm<InviteFormData>();

  const onSubmit = (data: InviteFormData) => {
    setFriends([...friends, { 
      id: Math.random().toString(36).substr(2, 9),
      email: data.email,
      status: 'pending'
    }]);
    reset();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-xl p-8"
        >
          <div className="text-center mb-8">
            <h1 className="text-3xl font-semibold text-gray-900">Split Your Stay</h1>
            <p className="mt-2 text-lg text-gray-600">
              Total Cost: {formatPrice(totalCost)}
            </p>
            <p className="text-sm text-gray-500 mt-1">
              Cost per person: {formatPrice(costPerPerson)}
            </p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="mb-8">
            <div className="flex gap-4">
              <div className="flex-1">
                <input
                  type="email"
                  {...register("email", { 
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address"
                    }
                  })}
                  placeholder="Enter friend's email"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
                )}
              </div>
              <Button type="submit" variant="primary">
                Add Friend
              </Button>
            </div>
          </form>

          <FriendsList 
            friends={friends}
            onRemoveFriend={(id) => setFriends(friends.filter(f => f.id !== id))}
            onSendReminder={(id) => {
              // Implementation for sending reminder
              console.log('Sending reminder to:', id);
            }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default InvitePage;